<template>
  <v-card flat @click="expanded = !expanded" class="bet-mobile">
    <v-list-item three-line>
      <v-list-item-action class="bet-bookie">
        <bookie-icon :bookie="bet.bookie" :size="30" />
      </v-list-item-action>

      <v-list-item-content>
        <v-list-item-title class="subtitle-1 mb-1">
          {{ bet.race }}
        </v-list-item-title>

        <v-list-item-subtitle>
          {{ betDate }}
        </v-list-item-subtitle>
        <v-list-item-subtitle> </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-chip :color="profitColor" outlined small v-if="bet.final">
          {{ betProfit }}
        </v-chip>
        <v-chip
          color="orange"
          dark
          small
          v-else-if="
            bet.outcome === 'REJECTED' &&
              (bet.processing_time < 5000 || bet.reject_reason === 'MANUAL')
          "
        >
          REJECTED
        </v-chip>
        <v-chip color="red" dark small v-else-if="bet.outcome === 'REJECTED'">
          REJECTED
        </v-chip>
        <v-chip color="grey" outlined small v-else>
          {{ bet.outcome }}
        </v-chip>

        <v-rating
          v-if="bet.final"
          class="mt-1"
          v-model="rating"
          background-color="grey lighten-1"
          :size="12"
          dense
          readonly
          :color="ratingColor"
        ></v-rating>
      </v-list-item-action>
    </v-list-item>

    <v-expand-transition>
      <bet-expanded v-if="expanded" :bet="bet" :mobile="true"></bet-expanded>
    </v-expand-transition>
  </v-card>
</template>

<script>
import moment from "moment";
import BetExpanded from "./BetExpanded";
import BookieIcon from "./BookieIcon";
import { currency } from "../lib/formatting";

export default {
  name: "BetMobile",
  props: ["bet"],
  components: {
    BetExpanded,
    BookieIcon
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    profitColor() {
      return this.bet.profit > 0 ? "green" : "red";
    },
    rating() {
      if (this.bet.ev < -10) return 1;
      if (this.bet.ev <= 0) return 2;
      if (this.bet.ev <= 10) return 3;
      if (this.bet.ev <= 50) return 4;
      if (this.bet.ev > 50) return 5;

      return 0;
    },
    ratingColor() {
      if (this.bet.ev <= 0) return "red";
      if (this.bet.ev <= 10) return "yellow darken-3";
      return "green";
    },
    betDate() {
      return moment(this.bet.date).format("ll LT");
    },
    betProfit() {
      return this.currency(this.bet.profit);
    }
  },
  methods: {
    currency(amt, decimals) {
      return currency(amt, decimals);
    }
  }
};
</script>

<style lang="scss">
.bet-info:not(:first-child) {
  margin-left: 20px;
}

.bet-profit {
  position: absolute;
  right: 16px;
}

#bets {
  .bet-win {
    color: green;
  }

  .bet-lose {
    color: red;
  }
}

.bet-mobile {
  .bet-bookie.v-list-item__action {
    margin-right: 16px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .v-list-item {
    padding-left: 0px;
  }
}
</style>
